import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  Grid,
  ClickAwayListener,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import BlueLightOutLinedMediumButton from "../../../STMPages/components/customButtons/BlueLightOutLinedMediumButton";
import NoSessionsAvailable from "../../../STMPages/pages/testPrepDashboard/dashboardComp/upcommingSessionCalander/components/NoSessionsAvailable";
import Loader from "../Loader/Loader";
import { useNavigate } from "react-router-dom";
import { deleteAllNotifications, readAllNotifications } from "../../api/notification";
import SussceeffulyMessageScreen from "../../../STMPages/components/customPopup/SussceeffulyMessageScreen";
import AnimatedSnackbar from "../../../STMPages/components/snackbars/AnimatedSnackbar";
import DeleteConfirmationPopup from "../../../STMPages/components/customPopup/DeleteConfirmationPopup";
import ErrorPopupScreen from "../../../STMPages/components/customPopup/ErrorPopupScreen";
import { socket } from "../../../socket";

/* ================= DATE LABEL HELPER ================= */

const getDateLabel = (date) => {
  const d = new Date(date);
  const today = new Date();

  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);

  const diffDays = Math.floor((today - d) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return d.toLocaleDateString("en-US", { weekday: "long" });

  return `${diffDays} days ago`;
};

/* ==================================================== */

export default function NotificationMenu({
  anchorEl,
  open,
  onClose,
  notifications,
  notificationLoading,
  setNotifications,
}) {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [menuPosition, setMenuPosition] = useState(null);

  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const statusIcon = {
    success: (
      <img src="/newdashboard/Dashboard Notification/Group 1171285254.png" />
    ),
    // warning: <ErrorIcon color="warning" />,
    error: (
      <img src="/newdashboard/Dashboard Notification/Group 1171285253.png" />
    ),
  };

  useEffect(() => {
    if (open && anchorEl) {
      const rect = anchorEl.getBoundingClientRect();

      setMenuPosition({
        top: rect.bottom + 12, // ❌ no scrollY
        left: rect.right - 380,
      });
    }
  }, [open, anchorEl]);

  useEffect(() => {
    if (open || snackbarOpen) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [open, snackbarOpen]);

  useEffect(() => {
    if (!socket) return;
    const handleNewNotification = (data) => {
      setNotifications((prev) => [data, ...prev]);
    };
    socket.on("receive_message", handleNewNotification);
    return () => socket.off("receive_message", handleNewNotification);
  }, []);

  const handleNotificationClick = (item) => {
    if (item?.dashboard_type === "test-prep") {
      if (item?.notification_type === "Demo") navigate("/test-prep/demos");
      if (item?.notification_type === "Class") navigate("/test-prep/classroom");
      if (item?.notification_type === "Payment")
        navigate("/test-prep/payment-history");
    }

    if (item?.dashboard_type === "sap") {
      if (item?.notification_type === "Payment")
        navigate("/sap/payment-history");
    }

    onClose();
  };

  const handleOpendeletePopup = (e, rowId) => {
    e.stopPropagation();
    setOpenDeleteConfirmation(true);
    // setSelectedRowId(rowId);
  };

  const handleClosedeletePopup = (e) => {
    e?.stopPropagation();
    setOpenDeleteConfirmation(false);
  };

  const handleDeleteOneNotifications = async (rowId) => {
    try {
      const response = await deleteAllNotifications({
        user_id: parseInt(userId),
        notification_id: [rowId],
      });
      if (response.status === 200) {
        showSnackbar(response.message, "success");
        setNotifications((prev) => prev.filter((item) => item.id !== rowId));
      } else showSnackbar(response.message, "error");
    } catch (err) {
      showSnackbar(err, "error");
    }
  };

  const handleDeleteAllNotifications = async () => {
    try {
      const response = await deleteAllNotifications({
        user_id: parseInt(userId),
        notification_id: notifications.map((item) => item.id),
      });
      if (response.status === 200) {
        setNotifications([]);

        handleClosedeletePopup();
        handleOpenSuccessPopup();
      } else setErrorMessage(response.message, "error");
    } catch (err) {
      setErrorMessage(err, "error");
    }
  };

  if (!open || !anchorEl || !menuPosition) return null;

  // Calculate absolute position relative to anchor
  const anchorRect = anchorEl.getBoundingClientRect();
  const style = {
    position: "fixed", // 🔥 key fix
    top: menuPosition.top,
    left: menuPosition.left,
    width: 410,
    maxHeight: 400,
    overflowY: "auto",
    zIndex: 1300,
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0px 8px 30px rgba(0,0,0,0.4)",
    padding: 16,
  };

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);

  const handleCloseSuccessPopup = () => {
    setOpenSuccesPopup(false);
    // onClose(); // ✅ close notification dropdown HERE
  };

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  /* ================= GROUP BY DATE LABEL ================= */

  const groupedNotifications = notifications.reduce((acc, item) => {
    const label = getDateLabel(item.createdAt);
    if (!acc[label]) acc[label] = [];
    acc[label].push(item);
    return acc;
  }, {});

  /* ================= RENDER ITEM ================= */

  const renderNotifications = (list) =>
    list.map((item, idx) => (
      <Grid item xs={12} key={item.id}>
        <Grid container spacing={2}>
          <Grid item xs="auto">
            <Box width={30}>{statusIcon[item.message_type]}</Box>
          </Grid>

          <Grid item xs>
            <Typography
              fontWeight={500}
              fontSize={15}
              fontFamily="Inter"
              color="#000000"
            >
              {item.notification_title}
            </Typography>
            <Typography
              fontSize={12}
              mt={0.5}
              color="#444"
              fontFamily="Inter"
              fontWeight={500}
            >
              {item.notification_sub_title}
            </Typography>

            <Box display="flex" justifyContent="space-between" mt={1}>
              <BlueLightOutLinedMediumButton
                buttonTitle="View Details"
                fontSize="12px"
                minWidth="100px"
                onClick={() => handleNotificationClick(item)}
              />
              <DeleteIcon
                sx={{ color: "#E30404", cursor: "pointer", fontSize: "1rem" }}
                onClick={() => handleDeleteOneNotifications(item.id)}
              />
            </Box>
          </Grid>

          {idx !== list.length - 1 && (
            <Grid item xs={12}>
              <Divider sx={{ width: "100%",}}/>
            </Grid>
          )}
        </Grid>
      </Grid>
    ));

  const enableScroll = notifications.length > 1;

  const containerStyle = {
    position: "fixed",
    top: menuPosition.top,
    left: menuPosition.left,
    width: 410,
    background: "#fff",
    borderRadius: 16,
    // padding: 16,
    
    boxShadow: "0px 8px 30px rgba(0,0,0,0.4)",
    zIndex: 1300,
    paddingBottom:10
  };

  const listStyle = {
    maxHeight: enableScroll ? "50vh" : "auto",
    overflowY: enableScroll ? "auto" : "visible",
    paddingRight: enableScroll ? 0 : 0, // scrollbar spacing

    "&::-webkit-scrollbar": {
      width: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#999999", // purple like your screenshot
      borderRadius: "3px",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: "#999999", // purple on hover
    },
    "&::-webkit-scrollbar-track": {
      background: "#f5f5f5",
      borderRadius: "3px",
    },
  };

  return (
    <ClickAwayListener onClickAway={onClose}>
      <div style={containerStyle}>
        {/* Header */}

        <Box display="flex" justifyContent="space-between" alignItems="center" px="16px" py={1}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: 18,
              fontFamily: "Inter",
              color: "#161719",
            }}
          >
            Notification
          </Typography>
          {notifications.length > 0 && (
            <Typography
              sx={{
                cursor: "pointer",
                color: "#572575",
                fontSize: 14,
                fontFamily: "Inter",
              }}
              onClick={() => setOpenDeleteConfirmation(true)}
            >
              Clear All
            </Typography>
          )}
        </Box>

        <Divider sx={{ my: 1 }} />

        <Box sx={listStyle}>
          <Grid container spacing={2} px="16px" >
            {/* Notifications */}
            {notificationLoading ? (
              <Grid item xs={12}>
                <Loader text="Loading..." height="40vh" />
              </Grid>
            ) : notifications.length > 0 ? (
              Object.entries(groupedNotifications).map(
                ([label, list], index, arr) => (
                  <React.Fragment key={label}>
                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#555555",
                          fontFamily: "Inter",
                        }}
                      >
                        {label}
                      </Typography>
                    </Grid>
                    {renderNotifications(list)}
                    {/* 🔥 Divider between date groups */}
                    {index !== arr.length - 1 && (
                      <Grid item xs={12} mt={0}>
                        <Divider />
                      </Grid>
                    )}
                  </React.Fragment>
                )
              )
            ) : (
              <Grid
                item
                xs={12}
                height="40vh"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <NoSessionsAvailable
                  topImage={
                    <img src="/newdashboard/Dashboard Notification/Group 1171285260.png" />
                  }
                  text="No notifications yet"
                  subText="You’re all caught up! Any updates about demos, payments, or classes will appear here."
                  imageSize={120}
                />
              </Grid>
            )}
          </Grid>
        </Box>

        {/* Popups */}
        <DeleteConfirmationPopup
          open={openDeleteConfirmation}
          text="Delete Confirmation ?"
          subtext="Are you sure you want to clear all notifications?"
          buttonTitle="Yes, Remove It"
          handleClose={(e) => handleClosedeletePopup(e)}
          handleSubmit={handleDeleteAllNotifications}
        />

        <SussceeffulyMessageScreen
          open={openSuccesPopup}
          text="All Notifications Deleted Successfully !"
          subText="You’re all caught up! All notifications have been deleted successfully."
          buttonTitle="Thanks, Got it"
          handleClose={handleCloseSuccessPopup}
          refreshPage={false}
        />

        <AnimatedSnackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          message={snackbarMessage}
          severity={snackbarSeverity}
        />
        <ErrorPopupScreen
          open={openErrorPopup}
          handleClose={handleCloseErrorPopup}
          subText={errorMessage}
          buttonTitle="Got It"
          maxWidth="xs"
        />
      </div>
    </ClickAwayListener>
  );
}
